<div class="content">


  <div class="form-groups-column buffer-bottom">
    <div class="form-group">
      <label>Firstname</label>
      <input type="text" class="form-control" [(ngModel)]="firstname" />
    </div>

    <div class="form-group">
      <label>Lastname</label>
      <input type="text" class="form-control" [(ngModel)]="lastname" />
    </div>

    <div class="form-group">
      <label>Email</label>
      <input type="email" class="form-control" [(ngModel)]="email" />
    </div>

    <div class="form-group">
      <label>Password</label>
      <input type="password" name="password1" class="form-control" [(ngModel)]="password" placeholder="unchanged" autocomplete="off" />
    </div>

    <div class="form-group">
      <label>Confirm Password</label>
      <input type="password" name="password2" class="form-control" [(ngModel)]="password2" placeholder="unchanged" autocomplete="off" />
    </div>

    <div class="form-group">
      <label>User Type</label>
      <app-user-profile-picker [userId]="userId" (onProfileSet)="setUserProfile($event)"></app-user-profile-picker>
    </div>

  </div>

  <div class="form-groups-column buffer-bottom" *ngIf="userId == 2">
    <div class="form-group">
      <label>Company</label>
      <app-company-picker [accountId]="companyId" (onCompanySet)="setCompanyId($event)"></app-company-picker>
    </div>

    <div class="form-group" *ngIf="companyId != undefined">
      <label>Locations</label>
      <div class="add-on-control">
        <app-location-picker [locationId]="locationId" [companyId]="companyId"
                             style="width:100%"
                             (onLocationSet)="onLocationChange($event)">

        </app-location-picker>
        <button type="button" class="core-btn add-on" (click)="addLocation(locationId)"><i class="fa fa-plus" style="margin-right:0px" aria-hidden="true"></i></button>
        <button type="button" class="core-btn add-on" (click)="addAllLocations()">Add All</button>

      </div>
    </div>

    <div class="col-md-6" *ngIf="companyId != undefined">
      <div class="form-group">
        <label>Assigned Locations</label>

        <table style="width:100%">
          <tr>
            <th style="padding:1%;width: 40%;border: 1px solid #ccc;">Location</th>

            <th style="padding:1%; width: 15%; border: 1px solid #ccc;">Remove</th>
          </tr>
          <ng-container *ngFor="let q of selectedLocations">
            <tr>
              <td style="padding:1%;width: 40%;border: 1px solid #ccc;">{{ q.name }} </td>
              <td style="padding:1%;width: 15%;border: 1px solid #ccc;">
                <div style="display: flex; flex-direction: column; align-items: center;">
                  <span class="remove-option" (click)="removeLocation(q.id)">
                    <i class="fa fa-trash" aria-hidden="true"></i>Remove
                  </span>
                </div>
              </td>
            </tr>
          </ng-container>
        </table>
      </div>
    </div>
  </div>




  <div class="action-buttons">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <div class="spacer" *ngIf="id != null"></div>
    <button *ngIf="id != null" class="btn btn-danger btn-save" (click)="delete()">Deactivate</button>
    <div class="spacer"></div>
    <button class="btn btn-back" (click)="back()">Back</button>
  </div>
</div>
